import { gql, GraphQLClient } from "graphql-request";
import { createGraphqlClient, type GraphqlRequestConfig } from "./client";

// ========== GraphQL Queries ==========

const GET_MY_LEVEL_INFO_QUERY = gql`
  query GetMyLevelInfo {
    myLevelInfo {
      level
      rank
      totalXp
      xpToNextLevel
      progressPercent
    }
  }
`;

const GET_USER_COUNT_QUERY = gql`
  query GetUserCount {
    userCount
  }
`;

// ========== Types ==========

export interface UserLevelInfo {
  level: number;
  rank: string;
  totalXp: number;
  xpToNextLevel: number;
  progressPercent: number;
}

export interface GraphqlUserLevelOptions extends GraphqlRequestConfig {
  client?: GraphQLClient;
}

function ensureClient(options?: GraphqlUserLevelOptions) {
  if (options?.client) {
    return options.client;
  }
  return createGraphqlClient(options);
}

// ========== API Functions ==========

/**
 * 現在のユーザーのレベル情報を取得
 */
export async function getMyLevelInfo(
  options?: GraphqlUserLevelOptions
): Promise<UserLevelInfo | null> {
  const client = ensureClient(options);
  const data = await client.request(GET_MY_LEVEL_INFO_QUERY);
  return (data as any).myLevelInfo;
}

/**
 * 登録ユーザーの総数を取得。「N人が勉強中」バッジ用
 */
export async function fetchUserCount(
  options?: GraphqlUserLevelOptions
): Promise<number> {
  const client = ensureClient(options);
  const data = await client.request(GET_USER_COUNT_QUERY);
  return (data as any).userCount;
}
